import { API_NODE_CERT_VAL, API_JAVA_AUTH, API_NODE_OBTER_PERFIL, API_NODE_CERT_SITUACAO, API_NODE_CERT_BLOQ, API_NODE_DADOS_OUTORGANTE, API_NODE_SERV_OUTORGA } from './../app.api';
import { HttpClient } from '@angular/common/http';
import { Injectable, NgZone, ɵConsole } from '@angular/core';
import { MessageService } from './message.service';
import { HttpUtilService } from './http-util.service';
import { Router } from '@angular/router';
import { Observable, throwError, pipe, Subject } from 'rxjs';
import{ GlobalCripto } from './../global/global-constants';
import Utils from './../utils/utils';
import { CertValidator } from './certvalidator.service';


@Injectable({
  providedIn: 'root'
})
export class CertificadoService {

  constructor(
    private http: HttpClient,
    private messageService: MessageService,
    private httpUtilService: HttpUtilService,
    private router: Router,
    private zone: NgZone) {CertValidator }

  private messageError: [number, string];
  private messageSucess: [number, string];
  private certificadoBloqueado: boolean;
  private certificadoValido: boolean;
  private certificadoAutorizado = false;
  private items = 'items';

  private certificadoKriptonite: any;


  private certificateSign;


  OnInit() {

    this.messageService.currentErrorMessage.subscribe(messageError => {
      if (messageError) { this.messageError = [messageError[0], messageError[1]]; }
    });
    this.messageService.currentSucessMessage.subscribe(messageSucess => {
      if (messageSucess) { this.messageSucess = [messageSucess[0], messageSucess[1]]; }
    });

 
    if (!GlobalCripto.clientAPI) {
      console.log(' ClientAPI não foi instanciado...')
      
      }

  }

  

  async certificadoPermitido(index): Promise<any> {
    return this.httpUtilService.get(API_JAVA_AUTH)
      .toPromise()
      .then(response => {
        sessionStorage['token'] = response['data']['token'];
        return this.certificadoAutorizado = true;
      })
      .catch(err => {
        console.error('Erro no envio', err);
        if (index) {
          this.messageService.changeErrorMessage(index, 'Certificado não permitido !');
        } else {
          this.messageService.changeErrorMessage(index, 'Certificado não permitido !');
        }
        this.router.navigate(['/acesso-negado']);
        return this.certificadoAutorizado = false;
      });
  }

  async isCertificadoValido(codigoSerial: string, index): Promise<any> {
    return this.http.get<{ res: string }>(`${API_NODE_CERT_VAL}${codigoSerial}`, this.httpUtilService.headers())
      .toPromise()
      .then(response => {
        this.certificadoValido = response[this.items][0] !== undefined ? true : false;
        if (this.certificadoValido) {
          return this.certificadoValido;
        } else {
          this.messageService.changeErrorMessage(index, 'Certificado não é valido !');
          this.router.navigate(['/acesso-negado']);
          return this.certificadoValido;
        }
      })
      .catch(err => {
        console.error('Erro', err);
        this.messageService.changeErrorMessage(index, 'Certificado não permitido !');
        this.router.navigate(['/acesso-sem-servico-node']);
        return this.certificadoValido = null;
      });
  }


  async isCertificadoBloqueado(inscricaoCertificado: string, index): Promise<any> {
    return this.http.get<{ res: string }>(`${API_NODE_CERT_BLOQ}${inscricaoCertificado}`, this.httpUtilService.headers()) // 141533837000183
      .toPromise()
      .then(response => {
        this.certificadoBloqueado = response[this.items][0]['bloqueio'].toString() === '0' ? false : true;
        if (!this.certificadoBloqueado) {
          return this.certificadoBloqueado;
        } else {
          if (index) {
            this.messageService.changeErrorMessage(index, 'Certificado bloqueado !');
          } else {
            this.messageService.changeErrorMessage(index, 'Certificado bloqueado !');
          }
          this.router.navigate(['/acesso-negado']);
          return this.certificadoBloqueado;
        }
      })
      .catch(err => {
        console.error('Erro', err);
        this.messageService.changeErrorMessage(index, 'Certificado não permitido !');
        this.router.navigate(['/acesso-sem-servico-node']);
        return this.certificadoBloqueado = true;
      });
  }

  async listarDadosCertificado(codigoSerial: string): Promise<any> {
    return this.http.get<{ res: string }>(`${API_NODE_CERT_VAL}${codigoSerial}`, this.httpUtilService.headers())
      .toPromise()
      .then(response => {
        const dadosCertificado = response[this.items][0];
        const certificadoValido = true;
        return dadosCertificado;
      })
      .catch(err => {
        console.error('Erro', err);
        this.router.navigate(['/acesso-sem-servico-node']);
        this.certificadoValido = false;
      });
  }

  private obterCn(issuerFull, position) {
    const issuer = issuerFull.toString().split(',');
    return issuer[position].trim();
  }

  obterDadosCertificadoServlet() {
    return this.httpUtilService.obterDadosCertificado();
  }

  async obterNomePerfil(nuPerfil: number): Promise<any> {

    return this.http.get<{ res: string }>(`${API_NODE_OBTER_PERFIL}${nuPerfil}`, this.httpUtilService.headers())
      .toPromise()
      .then(response => {
        const { de_perfil } = response[this.items][0];
        return de_perfil;
      })
      .catch(err => {
        console.error('Erro', err);
      });
  }
  async consultaServicosOutorga(outorgante, outorgado) {
    const body = JSON.stringify({ 'P_NUOUTORGANTE_IN': outorgante, 'P_NUOUTORGADO_IN': outorgado });
    return this.http.post<{ res: string }>(`${API_NODE_SERV_OUTORGA}`, body, this.httpUtilService.headers())
      .toPromise()
      .then(response => {
        return response['ResultSet 1 Output'];
      })
      .catch(err => {
        console.error('Erro', err);
      });
  }

  filterCertificado(index, certificados, certificadoServlet) {
    const cert = certificados.filter((cer) => {
      return cer.serial === certificadoServlet.codSerialHexaInvert;
    });
    this.messageService.changeFileProgress(index, 40);
    return cert[0];
  }

  async consultaDadosOutorgante(outorgante) {
    return this.http.get<{ res: string }>(`${API_NODE_DADOS_OUTORGANTE}${outorgante}`, this.httpUtilService.headers())
      .toPromise()
      .then(response => {
        return response['items'][0];
      })
      .catch(err => {
        console.error('Erro', err);
      });

  } 

  async dadosCertificado(codigoSerial: string, nomeAutoridade, index): Promise<any> {
    return await this.http.get<{ res: string }>(`${API_NODE_CERT_SITUACAO}${codigoSerial}/${nomeAutoridade}`, this.httpUtilService.headers())
      .toPromise()
      .then(response => {
        return response['items'][0];
      
      })
      .catch(err => {
        console.error('Erro', err);
        //this.messageService.changeErrorMessage(index, 'Certificado não permitido!'); 
        this.router.navigate(['/acesso-sem-servico-node']);
        return this.certificadoValido = false;
      });
  }


  async isCertificadoSituacao(codigoSerial: string, nomeAutoridade, index): Promise<any> {
    return await this.http.get<{ res: string }>(`${API_NODE_CERT_SITUACAO}${codigoSerial}/${nomeAutoridade}`, this.httpUtilService.headers())
      .toPromise()
      .then(response => {
        const situacao = response['items'][0].situacao;
        if (situacao === 2) {
          return true;
        }
        else {
          this.trataRegistroInvalido(situacao);
          return false;
        }

      })
      .catch(err => {
        console.error('Erro', err);
        // this.messageService.changeErrorMessage(index, 'Certificado não permitido!');         
        // this.router.navigate(['/acesso-negado']);
        return this.certificadoValido = false;
      });
  }





  public trataRegistroInvalido(situacao: number) {
    const index = 0;
    switch (situacao) {
      case 0:

        this.messageService.changeErrorMessage(index, 'Certificado Não Registrado !');
        break;
      case 1:
        this.messageService.changeErrorMessage(index, 'Certificado pré-autorizado. Aguarde aprovação do administrador.');
        break;
      case 2:
        this.messageService.changeErrorMessage(situacao, 'Certificado já Autorizado !');
        break;
      case 3:
        this.messageService.changeErrorMessage(situacao, 'Certificado Não Autorizado !');
        break;
      case 4:
        this.messageService.changeErrorMessage(situacao, 'Identificamos que seu certificado digital/token conectividade encontra-se revogado.');
        break;
      case 5:
        this.messageService.changeErrorMessage(situacao, 'Não é possível realizar o registro. Acusamos o suspensão do registro. Favor acionar a central de tele serviços CAIXA conforme orientações no site WWW.CAIXA.GOV.BR/ATENDIMENTO');
        break;
      // case 6:
      //   this.messageService.changeErrorMessage(index, 'Contrato renovado !');
      //   break;   
      case 7:
        this.messageService.changeErrorMessage(situacao, 'Usuário Revogou !');
        break;
      default:
        this.messageService.changeErrorMessage(situacao, 'Certificado inválido !');
    }
  }


  async assinarCriptoCns(certificadoServlet,  termo, attach) {
          
    try {
    //lista dos certificados do browser   krypton
     let certificados =  await GlobalCripto.clientAPI.sign.enumerateCerts();   
          
    //valida é obtem o certificado para assinar.
    const certificado = await this.filterCertificadoCripto(0,certificados, certificadoServlet);
    
   //XAPIRIPE assinar
   const assinado = await GlobalCripto.clientAPI.sign.sign({ certificate: certificado, toBeSigned: termo, attach })
  
   return assinado;
  }
	catch (e) {
		console.log('erro: ' + e.message);
		return '';
	}
  }
  async filterCertificadoCripto(index, certificados, certificadoServlet) {

    let cert = [];
      let matcher = new CertValidator(certificadoServlet.issuer.name, certificadoServlet.codSerialHexaInvert);
	    
	      //'Teste de comparação de issuer e serial...'
        certificados.forEach(item => {
          //retirar o ternario quando for ajustado o componente do criptoCns para retornar o issuer igual ao Kriptonita
          //Manter o matcher.match
		      let match = (GlobalCripto.apiAtiva !==  'Kryptonite') ?
              ((item.issuer === matcher.getFieldFromDN('CN')) && (item.serial.toUpperCase() === certificadoServlet.codSerialHexaInvert))
              : matcher.match(item.issuer, item.serial);

              if(match === true){
                cert.push(item);
              };
       
	      });
	  
        return cert[0]; 
    /*
    //nome da autoridade certificado logado
    const autoridadeCertificada =  this.getNomeAutoridadeCertificada(certificadoServlet);
    
    const cert = certificados.filter((cer) => {   
      let issuer = (GlobalCripto.apiAtiva !==  'Kryptonite') ? cer.issuer : this.getNomeAutoridadeCertificadaKry(cer.issuer);
      return  ( cer.serial.toUpperCase()  === certificadoServlet.codSerialHexaInvert.toUpperCase() )  &&
      ( issuer  === autoridadeCertificada)
    });
    this.messageService.changeFileProgress(index, 40);
    return cert[0];
    */
  }

  /*
  //Pegar nome do autoridade certificado listado no browser qdo for kry
  */
 getNomeAutoridadeCertificadaKry(response) {
  const cn = 'CN=';
  const pos = response.toString().indexOf(cn);
  const dadosIssuer = response.toString().split(',');
  const certificadoCn = (pos >= 0) ?  dadosIssuer[3].toString().substr(4) : dadosIssuer[3];
  return certificadoCn;
}

/*
  //Pegar nome do autoridade certificado do certificado logado
  */
 getNomeAutoridadeCertificada(response) {
  const cn = 'CN=';
  const pos = response.issuer.name.toString().indexOf(cn);
  const dadosIssuer = response.issuer.name.toString().split(',');
  const certificadoCn = (pos === 0) ?  dadosIssuer[0].toString().substr(pos+3) : dadosIssuer[0];
  return certificadoCn;
}

}
